/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const tag = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      clipPath="url(#tag_svg__a)"
    >
      <path d="M1 1.967V6c0 .513.204 1.005.567 1.368l7.496 7.496a.49.49 0 0 0 .816-.247l.79-3.949 3.948-.79c.373-.074.51-.554.247-.815L7.368 1.567A1.934 1.934 0 0 0 6 1H1.967A.976.976 0 0 0 1 1.967Z" />
      <path d="M4.384 5.35a.967.967 0 1 0 0-1.933.967.967 0 0 0 0 1.934Z" />
    </g>
    <defs>
      <clipPath id="tag_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default tag
